import TabAccount from './src/tab-account';

export default TabAccount;
